import { motion } from "framer-motion";
import { ArrowUpRight, Share2 } from "lucide-react";
import { PLATFORMS, SOCIALS } from "@/data/content";
import CtaBand from "@/components/CtaBand";

export default function Connect() {
  return (
    <>
      <section className="page-hero" data-testid="connect-hero">
        <div className="eyebrow gold">My Platforms & Social Connect</div>
        <h1>Saare official links, <span className="accent">ek jagah.</span></h1>
        <p>Plans compare karein, accounts kholein ya seedha social media par judiye — sab verified official links.</p>
      </section>
      <section className="section" data-testid="platforms-section">
        <div className="section-head">
          <div>
            <div className="eyebrow blue">Business platforms</div>
            <h2>Plans check karne ke liye <span className="accent">official partner links.</span></h2>
          </div>
          <p>Har link Utkarsh Gupta ka authorised partner page hai — aap directly plan dekh sakte hain ya enquiry kar sakte hain.</p>
        </div>
        <div className="platform-grid">
          {PLATFORMS.map((p, i) => (
            <motion.a key={p.name} href={p.url} target="_blank" rel="noopener noreferrer" className="platform-card" initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 4) * 0.06 }} data-testid={`platform-card-${p.name.toLowerCase().replaceAll(/[^a-z0-9]+/g, "-")}`}>
              <span className="platform-tag">{p.tag}</span>
              <h3>{p.name}</h3>
              <p>{p.desc}</p>
              <span className="platform-go">Visit <ArrowUpRight size={14} /></span>
            </motion.a>
          ))}
        </div>
      </section>
      <section className="section section-light" data-testid="socials-section">
        <div className="section-head centered">
          <div className="eyebrow gold"><Share2 size={13} /> Follow & connect</div>
          <h2>Social media par <span className="accent">judiye.</span></h2>
        </div>
        <div className="social-grid">
          {SOCIALS.map((s) => (
            <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" className="social-card" data-testid={`social-${s.name.toLowerCase().replaceAll(/[^a-z0-9]+/g, "-")}`}>
              {s.name} <ArrowUpRight size={15} />
            </a>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
